import React from 'react'
import { Container } from 'reactstrap'

import Welcomegreet from 'components/Welcomegreet'
import Privacycontent from './privacycontent'

function Privacy() {
  return (
    <React.Fragment>
    <div className="page-content">
         <Container fluid>
              <Welcomegreet/>
              <Privacycontent/>
         </Container>
    </div>
    </React.Fragment>
  )
}

export default Privacy